export const LOG_SET_INITIAL_STATE = 'LOG_SET_INITIAL_STATE';
export const LOG_FIND_ALL = 'LOG_FIND_ALL';
export const LOG_VIEW = 'LOG_VIEW';
